/* import __COLOCATED_TEMPLATE__ from './content-version-history.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();